import React from 'react';
import MerchantPortalAction from '../../../actions/MerchantPortalAction';
import MerchantPortalStore  from '../../../stores/MerchantPortalStore';
import CPButtom from '../Common/CPButton';

import moment from 'moment';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net-bs/css/dataTables.bootstrap.css';
const $ = window.$;
$.DataTable = require('datatables.net');



export default class CustomerFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = MerchantPortalStore.getCustomerDefaultSettings();
    this.state.isExpended = false;
    this.salesPerson = MerchantPortalStore.canUserSalesPerson();
  }
  _handleInputChange(type,event){
    let state = this.state;
    state[type] = event.target.value;
    this.setState(state);
  }
  clearFilter(){
    let settings = MerchantPortalStore.getCustomerDefaultSettings();
    let state = this.state;
    if(this.props.settings.perpage) settings.perpage = this.props.settings.perpage;
    this.refs.lastloginfrom.value = settings.lastloginfrom;
    this.refs.lastloginto.value = settings.lastloginto;
    this.refs.datecreatedfrom.value = settings.datecreatedfrom;
    this.refs.datecreatedto.value = settings.datecreatedto;
    let newSetting = { ...state, ...settings };
    this.setState(newSetting);
    this.props.setLoading();
    MerchantPortalAction.fetchCustomers(newSetting);
  }
  setFilter(event){
    event.preventDefault();
    let settings = this.state;
    settings.lastloginfrom = this.refs.lastloginfrom.value;
    settings.lastloginto = this.refs.lastloginto.value;
    settings.datecreatedfrom = this.refs.datecreatedfrom.value;
    settings.datecreatedto = this.refs.datecreatedto.value;
    if(settings.lastloginfrom && !settings.lastloginto) settings.lastloginto = new Date().toLocaleDateString('en-US').split`T`[0];
    if(settings.datecreatedfrom && !settings.datecreatedto) settings.datecreatedto = new Date().toLocaleDateString('en-US').split`T`[0];
    if(settings.lastloginto && !settings.lastloginfrom) settings.lastloginfrom = new Date().toLocaleDateString('en-US').split`T`[0];
    if(settings.datecreatedto && !settings.datecreatedfrom) settings.datecreatedfrom = new Date().toLocaleDateString('en-US').split`T`[0];
    this.props.setLoading();
    MerchantPortalAction.fetchCustomers(settings);
  }
  _toggleInactive(){
    this.setState({showInactiveUsers:!this.state.showInactiveUsers})
  }
  componentDidMount(){
    $("#lastloginfrom").datepicker({
      autoclose: true,
      format: 'mm/dd/yyyy',
      autoclose: true,
      endDate: new Date().toLocaleDateString('en-US').split`T`[0]
    }).on('changeDate', function (selected) {
      var minDate = new Date(selected.date.valueOf());
      $('#lastloginto').datepicker('setStartDate', minDate);
    });
    $("#lastloginto").datepicker({
      autoclose: true,
      format: 'mm/dd/yyyy',
      autoclose: true,
      endDate: new Date().toLocaleDateString('en-US').split`T`[0]
    }).on('changeDate', function (selected) {
      var minDate = new Date(selected.date.valueOf());
      $('#lastloginfrom').datepicker('setEndDate', minDate);
    });
    $("#datecreatedfrom").datepicker({
      autoclose: true,
      format: 'mm/dd/yyyy',
      autoclose: true,
      endDate: new Date().toLocaleDateString('en-US').split`T`[0]
    }).on('changeDate', function (selected) {
      var minDate = new Date(selected.date.valueOf());
      $('#datecreatedto').datepicker('setStartDate', minDate);
    });
    $("#datecreatedto").datepicker({
      autoclose: true,
      format: 'mm/dd/yyyy',
      autoclose: true,
      endDate: new Date().toLocaleDateString('en-US').split`T`[0]
    }).on('changeDate', function (selected) {
      var minDate = new Date(selected.date.valueOf());
      $('#datecreatedfrom').datepicker('setEndDate', minDate);
    });
  }
  _toggleExpanded(event){
    event.stopPropagation();
    this.setState({expanded:!this.state.expanded});
  }
  render(){
    return (
      <div className='div-customer-filter'>
        <div className='div-white-background'>
            <div className='filter-header' onClick={this._toggleExpanded.bind(this)}>
              <span data-translation='merchant.users.filterBy'>Find customers by:</span>
              <div className='d-block d-md-none flex-grow-1 text-right mr-2'><i className={"fa fa-chevron-"+(this.state.expanded?('up'):('down'))} /></div>
            </div>
            <form className={'filter-form '+(this.state.expanded?('show'):(''))} onSubmit={this.setFilter.bind(this)}>
              <div className='d-block d-md-flex flex-wrap'>
                <div className='form-group username'>
                  <label htmlFor="username" data-translation='merchant.users.user'>User</label>
                  <input type="text"
                          ref        = "username"
                          name       = "username"
                          disabled   = {this.state.isLoading? "disabled":""}
                          value      = {this.state.username}
                          onChange   = {this._handleInputChange.bind(this,'username')}
                          className  =  'form-control'
                          tabIndex   = '1'
                   />
                </div>
                <div className='form-group customer'>
                  <label htmlFor="customer" data-translation='merchant.users.customer'>Customer</label>
                  <input type="text"
                          ref        = "customer"
                          name       = "customer"
                          disabled   = {this.state.isLoading? "disabled":""}
                          value      = {this.state.customer}
                          onChange   = {this._handleInputChange.bind(this,'customer')}
                          className  =  'form-control'
                          tabIndex   = '2'
                   />
                </div>
                <div className="form-row lastlogin m-0">
                  <div className="form-group col col-12 mb-0">
                    <label htmlFor="referenceno" data-translation='merchant.users.lastLogin'>Last Login Date</label>
                  </div>
                  <div className="form-group col col-6 lastloginfrom">
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                    <input type="text" ref='lastloginfrom' className="form-control datepicker form-control-i" id="lastloginfrom" tabIndex= '3' autoComplete="off" defaultValue={this.state.lastloginfrom}></input>
                  </div>
                  <div className="form-group col col-6 lastloginto">
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                    <input type="text" ref='lastloginto' className="form-control datepicker form-control-i" id="lastloginto" tabIndex= '4' autoComplete="off" defaultValue={this.state.lastloginto}></input>
                  </div>
                </div>
                <div className="form-row datecreated m-0">
                  <div className="form-group col col-12 mb-0">
                    <label htmlFor="referenceno" data-translation='merchant.users.loginCreate'>Login Created Date</label>
                  </div>
                  <div className="form-group col col-6 datecreatedfrom">
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                    <input type="text" ref='datecreatedfrom' className="form-control datepicker form-control-i" id="datecreatedfrom" tabIndex= '5' autoComplete="off" defaultValue={this.state.datecreatedfrom}></input>
                  </div>
                  <div className="form-group col col-6 datecreatedto">
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                    <input type="text" ref='datecreatedto' className="form-control datepicker form-control-i" id="datecreatedto" tabIndex= '6' autoComplete="off" defaultValue={this.state.datecreatedto}></input>
                  </div>
                </div>
                <div className='form-group status'>
                  <label htmlFor="status" data-translation='merchant.users.status'>Status</label>
                  <select
                      ref        = "status"
                      name       = "status"
                      disabled   = {this.state.isLoading? "disabled":""}
                      value      = {this.state.status}
                      onChange   = {this._handleInputChange.bind(this,'status')}
                      className  =  'form-control'
                      tabIndex   = '7'
                  >
                    <option value='' data-translation='merchant.users.all'> All </option>
                    <option value='NeedsApproval' data-translation='merchant.users.NeedsApproval'> Needs Approval </option>
                    <option value='Active' data-translation='merchant.users.Active'> Active </option>
                    <option value='Inactive' data-translation='merchant.users.Inactive'> Inactive </option>
                    <option value='Declined' data-translation='merchant.users.Declined'> Declined </option>
                  </select>
                </div>
                <div className='form-group status userType'>
                  <label htmlFor="userType" data-translation='merchant.users.userType'>User Type</label>
                  <select
                      ref        = "userType"
                      name       = "userType"
                      disabled   = {this.state.isLoading? "disabled":""}
                      value      = {this.state.userType}
                      onChange   = {this._handleInputChange.bind(this,'userType')}
                      className  =  'form-control'
                      tabIndex   = '8'
                  >
                    <option value='' data-translation='merchant.users.all'> All </option>
                    <option value='User' data-translation='merchant.users.User'> User </option>
                    <option value='Merchant' data-translation='merchant.users.Merchant'> Merchant </option>
                    {this.salesPerson?(
                      <option value='Salesperson' data-translation='merchant.users.Salesperson'> Salesperson </option>
                    ):(false)}
                  </select>
                </div>
              </div>
              <div>
                <CPButtom className='btn-outline-custom w-mobile-100 ' type='button' onClick={this.clearFilter.bind(this)} disabled={this.props.isLoading} translationTag='merchant.users.clear'>Clear Filter</CPButtom>
                <CPButtom className='w-mobile-100 ' translationTag='merchant.users.filter' disabled={this.props.isLoading}>Filter</CPButtom>
                <div className="checkbox checkbox-checkbox mx-2 pl-4" onClick={this._toggleInactive.bind(this)}>
                      &nbsp;
                      <input
                          type="checkbox"
                          value = {this.state.showInactiveUsers}
                          checked={this.state.showInactiveUsers||false}
                          tabIndex='10'
                          readOnly
                      />
                      <span data-translation='merchant.users.showInactive'>Show Inactive users</span>
                      <div className="checkbox_box"></div>
                </div>
              </div>
            </form>
        </div>
      </div>
    );
  }
}
